module.exports = __webpack_public_path__ + "static/media/trainer5.a75a2486.jpg";